import { render } from "./BorderBlockStartWidth.vue?vue&type=template&id=47400daa&scoped=true&ts=true"
import script from "./BorderBlockStartWidth.vue?vue&type=script&lang=ts"
export * from "./BorderBlockStartWidth.vue?vue&type=script&lang=ts"

import "./BorderBlockStartWidth.vue?vue&type=style&index=0&id=47400daa&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47400daa"]])

export default __exports__